var _path, _path2, _g, _path3, _g2, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgSuper = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 38,
  height: 12,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11.45 7.401c-.52.334-1.425.446-1.808-.238-.102-.194-.208-.52.034-1.69l.66-3.183h-2.08l-.66 3.184c-.085.348-.367 1.69-.103 2.582.234.783.85 1.499 2.218 1.499.873 0 1.675-.457 1.904-.864v.658h1.943l1.47-7.059h-2.081l-.838 4.027c-.03.13-.199.788-.66 1.084Z",
  fill: "#FA2A5D"
})), /*#__PURE__*/React.createElement("mask", {
  id: "super_svg__a",
  style: {
    maskType: "luminance"
  },
  maskUnits: "userSpaceOnUse",
  x: 14,
  y: 2,
  width: 10,
  height: 10
}, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M14.33 2h9v10h-9V2Z",
  fill: "#fff"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#super_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M20.594 7.07c-.363.38-.825.64-1.48.609a1.38 1.38 0 0 1-1.2-.807c-.135-.326-.267-.76-.076-1.532.116-.47.427-.97.742-1.191.317-.221.738-.426 1.43-.315.69.111 1.117.693 1.17 1.38.052.687-.224 1.478-.586 1.856ZM23.05 3.8c-.419-.983-1.167-1.4-1.66-1.6-.492-.2-1.33-.311-2.084-.033-.756.278-1 .694-1 .694v-.657h-1.93L14.33 12h2.065l.79-3.777c.22.417.682.879 1.139 1.042.455.164 1.351.378 2.346 0 .994-.378 1.816-1.205 2.277-2.186.462-.98.522-2.296.104-3.279Z",
  fill: "#FA2A5D"
}))), /*#__PURE__*/React.createElement("mask", {
  id: "super_svg__b",
  style: {
    maskType: "luminance"
  },
  maskUnits: "userSpaceOnUse",
  x: 31,
  y: 2,
  width: 7,
  height: 8
}, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M31.885 2.178h6.003v7.336h-6.003V2.178Z",
  fill: "#fff"
}))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#super_svg__b)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M33.96 9.514h-2.075l1.478-7.22H35.3v.673c.953-.885 2.587-.786 2.587-.786l-.438 2.18s-.842-.349-1.695.097c-.711.372-.984 1.054-1.056 1.388-.086.366-.738 3.668-.738 3.668Z",
  fill: "#FA2A5D"
}))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M29.516 5.158h-2.93s.177-.549.69-1.007c.473-.425 1.384-.51 1.846-.088.462.421.394 1.095.394 1.095Zm2.055-.608a2.782 2.782 0 0 0-.933-1.712c-.726-.616-1.552-.734-2.307-.734-.755 0-1.896.208-2.886 1.226a4.538 4.538 0 0 0-1.208 3.97c.189 1.018 1.04 1.915 2.12 2.25 1.009.312 2.233.195 2.918-.015.684-.21 1.474-.704 1.474-.704l-.734-1.56a3.975 3.975 0 0 1-1.008.507c-.469.162-1.25.232-1.935-.103S26.365 6.5 26.365 6.5h5.139a6 6 0 0 0 .067-1.95ZM3.99 3.788c.668-.05 1.09.257 1.743.666l1.09-1.35s-.902-1-2.652-1-2.916.846-3.147 1.902c-.154.703.053 1.842 1.251 2.37 1.294.57 1.77.586 1.91.971.164.456-.625.928-1.555.667-.979-.275-1.351-.697-1.351-.697L.111 8.78s.984.961 2.887.961 2.965-.903 3.209-1.836c.238-.91-.122-1.51-.286-1.734a2.228 2.228 0 0 0-.989-.771 21.93 21.93 0 0 0-1.158-.413c-.226-.075-.695-.237-.706-.57-.015-.43.582-.6.921-.629Z",
  fill: "#FA2A5D"
})));
export default SvgSuper;